module.exports = __webpack_public_path__ + "static/img/video-pass-off.1401f4dc.png";